export const DOCTOR_SPECIALTIES = [
    "Endocrinologist",
    "Dietitian",
    "Cardiologist",
    "Family medicine",
    "Other",
];
const DOCTOR_SPECIALTY_SET = new Set(DOCTOR_SPECIALTIES);
export function isDoctorSpecialty(value) {
    return DOCTOR_SPECIALTY_SET.has(value);
}
export const DOCTOR_SPECIALTY_I18N_KEYS = {
    Endocrinologist: "endocrinologist",
    Dietitian: "dietitian",
    Cardiologist: "cardiologist",
    "Family medicine": "familyMedicine",
    Other: "other",
};
/** Backend: doctors.MaxSpecialtyLength */
export const SPECIALTY_MAX = 80;
/** Spaces trimmed and collapsed, as the backend stores a specialty */
export function cleanSpecialty(value) {
    return value.trim().replace(/\s+/g, " ");
}
/**
 * The Specialty menu (C2, C2.1): the fixed list without «Other», which is the row to type your
 * own, plus the doctor's current custom value, filtered by what's typed. «Add» appears when the
 * typed text isn't on the list. Labels are translated, values are what's saved.
 */
export function specialtyMenu(current, query, labelOf) {
    var _a;
    const label = (value) => isDoctorSpecialty(value) ? labelOf(value) : value;
    const all = DOCTOR_SPECIALTIES.filter((s) => s !== "Other").map((value) => ({ value, label: labelOf(value) }));
    if (current && !all.some((o) => o.value === current))
        all.push({ value: current, label: label(current) });
    const typed = cleanSpecialty(query);
    const needle = typed.toLowerCase();
    const match = (_a = all.find((o) => o.label.toLowerCase() === needle || o.value.toLowerCase() === needle)) !== null && _a !== void 0 ? _a : null;
    return {
        options: all.filter((o) => !needle || o.label.toLowerCase().includes(needle)),
        match: typed ? match : null,
        canAdd: Boolean(typed) && !match,
        typed,
    };
}
export function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value.trim().toUpperCase());
}
export function normalizeCountryCode(value) {
    const code = value.trim().toUpperCase();
    return isCountryCode(code) ? code : null;
}
